module.exports = __webpack_public_path__ + "static/media/Notify.e741be90.mp4";